export default __webpack_public_path__ + "0adbeee9afb5f4f619413b156ddfd1cf.png";